export default __webpack_public_path__ + "static/media/wpWebsiteAttempt.cc693fc2.png";